<template>
  <div class="automatic-recharge">
    <a
      href="#"
      class="btn btn-primary"
      @click.prevent="openAutomaticRechargeModal">Ativar Recarga Automática</a>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="automaticRechargeRequest"
      ref="automaticRechargeRequest"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-lg modal-dialog-centered automatic-recharge-modal"
        role="document">
        <div class="modal-content">
          <div class="modal-header automatic-recharge-modal-header">
            <div class="automatic-recharge-modal-header-left">
              <Icon name="sync-plus" :size="28" icon-class="automatic-recharge-modal-header-icon" />
              <h5 class="modal-title">Ativar Recarga Automática</h5>
            </div>
            <button
              type="button"
              class="close"
              @click.prevent="closeAutomaticRechargeModal">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body automatic-recharge-modal-body">
            <ErrorAlert :error="error" />
            <form
              ref="chargeForm"
              class="charge-form">
              <div class="row">
                <div class="col-lg-6 text-center">
                  <div class="form-group d-flex justify-content-center align-items-center">
                    <h5 class="mb-0 align-items-center automatic-recharge-label">
                      Ativar quando o saldo for <strong>menor</strong> que
                      <i
                        id="info-icon"
                        class="ik ik-info ml-2"
                        style="cursor: pointer;"
                      />
                    </h5>
                    <b-tooltip
                      placement="top"
                      target="info-icon">
                      Quando seu saldo chegar a este valor, uma nova recarga será feita automaticamente.
                    </b-tooltip>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-12 automaticRechargeAmount">
                      <CurrencyAmountInput
                        v-model="automaticRechargeMinimumAmount"
                        :min="5"
                        :max="5000"
                        @enter="generateAutomaticRecharge" />
                    </div>
                  </div>
                  <div class="form-group">
                    <h5 class="automatic-recharge-label">Informe o <b>valor</b> que deseja recarregar</h5>
                  </div>
                  <div class="form-group row">
                    <div class="col-sm-12 automaticRechargeAmount">
                      <CurrencyAmountInput
                        ref="automaticRechargeAmount"
                        v-model="automaticRechargeAmount"
                        :min="250"
                        :max="50000"
                        @enter="generateAutomaticRecharge" />
                    </div>
                  </div>
                  <div v-if="hasDynamicTariff">
                    <div class="form-group">
                      <p class="automatic-recharge-discount-label">Ou selecione o <b>desconto</b> deseja receber</p>
                    </div>
                    <div class="form-group row">
                      <div class="col automaticRechargeSlider">
                        <div
                          class="range-slider"
                          @click.prevent="sliderClick">
                          <input
                            class="form-control"
                            id="automaticRechargeSlider"
                            type="input"
                            data-slider-tooltip="hide"
                            :data-slider-ticks-snap-bounds="sliderTicksSnapBounds"
                            :data-slider-ticks-labels="sliderTicksLabels"
                            :data-ticks_positions="sliderTicksPositions">
                        </div>
                      </div>
                    </div>
                    <div class="form-group automatic-recharge-prices">
                      <div class="row">
                        <div class="col-lg-6"><span class="automatic-recharge-price-label">Minuto Móvel</span></div>
                        <div class="col-lg-6"><span class="automatic-recharge-price-label">Minuto Fixo</span></div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6"><span class="automatic-recharge-price-value">R$ {{ mobilePrice }}</span></div>
                        <div class="col-sm-6"><span class="automatic-recharge-price-value">R$ {{ fixedlinePrice }}</span></div>
                      </div>
                    </div>
                    <div class="automatic-recharge-economy">
                      <p v-if="automaticRechargeAmount >= 500">
                        Com esse desconto, a cada <b>1000 minutos</b> você economizará em média <b>R$ {{ averageSaving }},00</b>
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 text-left automatic-recharge-card-column">
                  <div class="form-group">
                    <h5 class="automatic-recharge-card-title">Dados do cartão de crédito</h5>
                  </div>
                  <div class="form-group">
                    <div
                      class="input-group automaticRechargeCardHolderName"
                      title="Nome impresso no Cartão de Crédito"
                      data-toggle="tooltip"
                      data-placement="top">
                      <div class="input-group-prepend">
                        <i class="input-group-text ik ik-user" />
                      </div>
                      <input
                        type="text"
                        ref="userCardHolderName"
                        class="form-control"
                        id="userCardHolderName"
                        placeholder="Nome no Cartão de Crédito"
                        v-model="userCardHolderName"
                        required>
                    </div>
                  </div>
                  <div class="form-group">
                    <div
                      class="input-group automaticRechargeCardNumber"
                      title="Número do Cartão de Crédito"
                      data-toggle="tooltip"
                      data-placement="top">
                      <div class="input-group-prepend">
                        <i class="input-group-text ik ik-credit-card" />
                      </div>
                      <input
                        type="text"
                        ref="userCardNumber"
                        class="form-control"
                        id="userCardNumber"
                        placeholder="Número do Cartão de Crédito"
                        :maxlength="userCardNumberLength"
                        v-model="userCardNumber"
                        @input="sanitizeCardNumber"
                        @paste="handlePaste"
                        required>
                    </div>
                  </div>
                  <div class="form-group">
                    <div
                      class="input-group automaticRechargeCardBrand"
                      title="Bandeira do Cartão de Crédito"
                      data-toggle="tooltip"
                      data-placement="top">
                      <div class="input-group-prepend">
                        <i class="input-group-text ik ik-flag" />
                      </div>
                      <input
                        type="text"
                        ref="userCardBrand"
                        class="form-control"
                        id="userCardBrand"
                        placeholder="Bandeira do Cartão de Crédito"
                        v-model="userCardBrand"
                        readonly
                        required>
                    </div>
                  </div>
                  <div class="form-group automatic-recharge-card-last">
                    <div class="d-flex">
                      <div
                        class="input-group"
                        title="Mês de Expiração"
                        data-toggle="tooltip"
                        data-placement="top">
                        <div class="input-group-prepend">
                          <i class="input-group-text ik ik-calendar" />
                        </div>
                        <select
                          class="form-control"
                          v-model="userCardExpiryMonth"
                          required>
                          <option
                            value="">MM</option>
                          <option
                            v-for="month in 12"
                            :value="month"
                            :key="month">{{ ('0' + month).slice(-2) }}</option>
                        </select>
                      </div>
                    <div
                      class="input-group mx-1"
                        title="Ano de Expiração"
                        data-toggle="tooltip"
                        data-placement="top">
                        <div class="input-group-prepend">
                          <i class="input-group-text ik ik-calendar" />
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="AAAA"
                          v-model="userCardExpiryYear"
                          maxlength="4"
                          required>
                      </div>
                      <div
                        class="input-group"
                        title="Código de Segurança"
                        data-toggle="tooltip"
                        data-placement="top">
                        <div class="input-group-prepend">
                          <i class="input-group-text ik ik-shield" />
                        </div>
                        <input
                          type="text"
                          class="form-control"
                          placeholder="CVV"
                          v-model="userCardSecurityCode"
                          :maxlength="userCardSecurityCodeLength"
                          required>
                      </div>
                    </div>
                  </div>
                  <p class="form-text text-muted small">Não salvamos os dados sensíveis do seu cartão.</p>
                  <div class="form-group automatic-recharge-financial-emails">
                    <label
                      for="automaticRechargeAdditionalEmails"
                      class="col-form-label d-flex align-items-center">
                      <i class="ik ik-mail mr-2" />
                      Confirme o e-mail do financeiro
                      <i
                        id="automatic-recharge-financial-emails-info"
                        class="ik ik-info ml-2"
                        style="cursor: pointer;" />
                    </label>
                    <b-tooltip
                      target="automatic-recharge-financial-emails-info"
                      triggers="hover"
                      placement="top">
                      Esses e-mails receberão notificações financeiras como envio de cobranças, confirmação de pagamento, notas fiscais e comprovantes.
                    </b-tooltip>
                    <input
                      id="automaticRechargeAdditionalEmails"
                      type="text"
                      class="form-control"
                      v-model="additionalEmails"
                      placeholder="email@exemplo.com, outro@exemplo.com">
                    <small class="form-text text-muted">Você pode adicionar até 5 e-mails separados por vírgula.</small>
                  </div>
                </div>
              </div>
            </form>
            <hr>
            <CompensationTermsMethods
              layout="row"
              description="Após a compensação, seus créditos são adicionados automaticamente." />
            <p v-if="showRechargeActiveUserLimitNotice" class="charge-limit-message">
              <button
                type="button"
                class="charge-limit-icon-btn"
                @click.prevent="goToSubscription">
                <i class="ik ik-info charge-limit-icon" />
              </button>
              <span>
                No modelo de recarga você tem limite de até {{ rechargeActiveUsersLimitLabel }} usuários.
                <a
                  href="#"
                  class="charge-limit-link"
                  @click.prevent="goToSubscription">
                  Aumente seu limite com modelo de planos &rarr;
                </a>
              </span>
            </p>
          </div>
          <div class="modal-footer automatic-recharge-modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn automatic-recharge-btn-cancel"
                @click.prevent="closeAutomaticRechargeModal">Cancelar</button>
              <button
                type="button"
                class="btn automatic-recharge-btn-submit"
                :disabled="(error && (error.message || error.lines)) ||
                (!userCardHolderName || !userCardNumber || !userCardExpiryMonth || !userCardExpiryYear || !userCardSecurityCode)"
                @click.prevent="generateAutomaticRecharge">Gerar recarga automática</button>
              <PlansCallToAction @click.prevent="closeAutomaticRechargeModal" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loopback from '@/services/loopback'
import { EventBus } from '@/services/event-bus'
import { getInviteEligibility, resolveInviteEligibilityMaxUsers, isOrganizationUserLimitExempt } from '@/services/invite-eligibility'
import { getClientIp } from '@/utils/network'
import DatepickerLanguages from '../Report/datepickerLanguages'
import PlansCallToAction from '@/components/Common/PlansCallToAction.vue'
import CompensationTermsMethods from '@/components/Common/CompensationTermsMethods.vue'
import CurrencyAmountInput from '@/components/Common/CurrencyAmountInput.vue'
import Icon from '@/components/Common/Icon.vue'
const cardValidator = require('card-validator')
const LEGACY_MOBILE_PRICES = ['0,35', '0,33', '0,30', '0,25', '0,19', '0,12']
const LEGACY_FIXEDLINE_PRICES = ['0,08', '0,079', '0,078', '0,076', '0,074', '0,07']

const MOBILE_PRICES = ['0,38', '0,36', '0,33', '0,28', '0,22', '0,15']
const FIXEDLINE_PRICE = '0,09'

const NEW_MOBILE_PRICES = ['0,41', '0,39', '0,36', '0,31', '0,25', '0,18']
const NEW_FIXEDLINE_PRICE = '0,09' // TEL-2294: sem valor próprio definido, assumido igual ao "Atual"

const CHARGE_AMOUNTS = [250, 500, 1000, 2000, 3000, 5000]
const CHARGE_AMOUNT_TIERS = [0, 5, 15, 30, 45, 65]
const CHARGE_AMOUNT_POSITIONS = [0, 20, 40, 60, 80, 100]
const MIN_RECHARGE_AMOUNT = 250
const MAX_RECHARGE_AMOUNT = 50000
const RECHARGE_AMOUNT_RANGE_MESSAGE = 'Recarga mínima é de R$ 250,00 e máxima de R$ 50.000,00'
const SUBMIT_DEBOUNCE_MS = 5000

export default {
  name: 'AutomaticRechargeNew',
  components: {
    Icon,
    PlansCallToAction,
    CompensationTermsMethods,
    CurrencyAmountInput
  },
  data () {
    return {
      sliderTicks: CHARGE_AMOUNT_POSITIONS,
      sliderTicksPositions: CHARGE_AMOUNT_POSITIONS,
      sliderTicksLabels: CHARGE_AMOUNT_TIERS.map(v => `${v}%`),
      sliderTicksSnapBounds: 20,
      error: null,
      showTooltip: false,
      automaticRechargeMinimumAmount: 20,
      automaticRechargeAmount: MIN_RECHARGE_AMOUNT,
      userCardHolderName: '',
      userCardNumber: '',
      userCardNumberLength: 16,
      userCardExpiryMonth: '',
      userCardExpiryYear: '',
      userCardSecurityCode: '',
      userCardSecurityCodeLength: 3,
      userCardBrand: '',
      clientIp: null,
      financialData: null,
      additionalEmails: '',
      rechargeActiveUsersLimit: null,
      inviteEligibilityCutoffDate: null,
      canInvite: true,
      isRateplanLegacy: typeof this.$store.state.auth.organization.isRateplanLegacy === 'boolean'
        ? this.$store.state.auth.organization.isRateplanLegacy
        : true,
      isRatePlanNew: typeof this.$store.state.auth.organization.isRatePlanNew === 'boolean'
        ? this.$store.state.auth.organization.isRatePlanNew
        : false,
      hasDynamicTariff: this.$store.state.auth.softswitchIntegration &&
        typeof this.$store.state.auth.softswitchIntegration.metadata.hasDynamicTariff === 'boolean'
        ? this.$store.state.auth.softswitchIntegration.metadata.hasDynamicTariff
        : true
    }
  },
  mounted () {
    getClientIp().then(ip => {
      this.clientIp = ip
    }).catch(() => {
      this.clientIp = null
    })
    this.getFinancialData()
    this.loadInviteEligibility()
    this.$nextTick(() => {
      $.fn.datepicker.dates['pt-BR'] = DatepickerLanguages['pt-BR']
      const functionToChangeDateEvent = this.changeDateEvent
      $('.input-daterange input').each(function () {
        $(this).datepicker({
          language: 'pt-BR',
          container: '#picker-container',
          autoclose: true,
          todayHighlight: true
        }).on('changeDate', functionToChangeDateEvent)
      })
      this.buildSlider()
    })
  },
  methods: {
    async loadInviteEligibility () {
      const eligibility = await getInviteEligibility()
      this.rechargeActiveUsersLimit = resolveInviteEligibilityMaxUsers(eligibility)
      this.inviteEligibilityCutoffDate = eligibility ? eligibility.cutoffDate : null
      this.canInvite = eligibility && eligibility.canInvite !== false
    },
    getAmountByPosition (position) {
      return CHARGE_AMOUNTS[CHARGE_AMOUNT_POSITIONS.findIndex(v => parseInt(v) === parseInt(position))]
    },
    getPositionByAmount (amount) {
      const positionIndex = CHARGE_AMOUNTS.reduce((findIndex, tier, index) => {
        if (parseInt(amount) >= parseInt(tier)) {
          findIndex = index
        }
        return findIndex
      }, 0)
      return positionIndex
    },
    getAmountPositionByAmount (amount) {
      return CHARGE_AMOUNT_POSITIONS[this.getPositionByAmount(amount)]
    },
    buildSlider () {
      $(`#automaticRechargeSlider`).slider({
        value: this.getAmountPositionByAmount(this.automaticRechargeAmount),
        ticks: this.sliderTicks,
        ticks_positions: this.sliderTicksPositions,
        ticks_labels: this.sliderTicksLabels,
        ticks_snap_bounds: this.sliderTicksSnapBounds
      }).on('slide', (slideEvt) => {
        this.automaticRechargeAmount = this.getAmountByPosition(slideEvt.value)
      })
    },
    sliderClick () {
      this.automaticRechargeAmount = this.getAmountByPosition($(`#automaticRechargeSlider`)[0].value)
    },
    resetCharge () {
      this.error = null
      this.automaticRechargeMinimumAmount = 20
      this.automaticRechargeAmount = MIN_RECHARGE_AMOUNT
      this.userCardHolderName = ''
      this.userCardNumber = ''
      this.userCardNumberLength = 16
      this.userCardExpiryMonth = ''
      this.userCardExpiryYear = ''
      this.userCardSecurityCode = ''
      this.userCardSecurityCodeLength = 3
      this.userCardBrand = ''
      this.syncAdditionalEmailsFromFinancialData()
    },
    syncAdditionalEmailsFromFinancialData () {
      this.additionalEmails = this.financialData && this.financialData.additionalEmails
        ? this.financialData.additionalEmails
        : ''
    },
    getFinancialData () {
      this.financialData = this.$store.state.auth.financialData
      this.syncAdditionalEmailsFromFinancialData()
    },
    generateAutomaticRecharge (event) {
      this.debounceSubmitSource(event)
      this.error = null
      if (!this.isRechargeAmountInRange()) {
        this.error = { message: RECHARGE_AMOUNT_RANGE_MESSAGE }
        return
      }
      this.saveFinancialEmailsIfDirty()
        .then(() => this.submitAutomaticRecharge())
        .catch(() => {})
    },
    saveFinancialEmailsIfDirty () {
      const isDirty = this.financialData &&
        String(this.additionalEmails || '').trim() !== String(this.financialData.additionalEmails || '').trim()
      if (!isDirty) return Promise.resolve()
      return loopback
        .put('/accounts/financial', { additionalEmails: this.additionalEmails })
        .then(updated => {
          if (updated) this.$store.commit('auth/setFinancialData', updated)
        })
        .catch(err => {
          const msg = err.message || ''
          if (msg.includes('additionalEmails: invalid')) {
            this.error = msg.includes('maximum 5 emails')
              ? { message: 'Máximo de 5 emails adicionais.' }
              : { message: 'Emails adicionais inválidos. Exemplo: "contato@dominio.com,financeiro@dominio.com"' }
          } else {
            // TEL-2243: `msg` e a mensagem do backend — nao vai para a tela.
            this.error = { lines: ['Não foi possível atualizar os e-mails.'] }
          }
          this.userCardFocus()
          return Promise.reject(err)
        })
    },
    submitAutomaticRecharge () {
      const payloadRecharge = {
        rechargeAmount: this.automaticRechargeAmount,
        minimumAmount: this.automaticRechargeMinimumAmount,
        cardHolderName: this.userCardHolderName,
        cardNumber: this.userCardNumber,
        cardExpiryMonth: this.userCardExpiryMonth,
        cardExpiryYear: this.userCardExpiryYear,
        cardSecurityCode: this.userCardSecurityCode,
        remoteIp: this.clientIp
      }

      loopback.post('/automatic-recharges', payloadRecharge).then(() => {
        const minimumAmount = this.automaticRechargeMinimumAmount
        const rechargeAmount = this.automaticRechargeAmount
        this.closeAutomaticRechargeModal()
        EventBus.$emit('reload-automatic-recharge')
        EventBus.$emit('automatic-recharge-success', {
          minimumAmount,
          rechargeAmount,
          source: 'create'
        })
      }).catch(err => {
        if (err.message === 'error to generate credit card token') {
          this.error = {
            message: `Ocorreu um erro: 'Transação não autorizada. Verifique os dados do cartão de crédito e tente novamente.'`
          }
        } else {
          // TEL-2243: o texto vem do normalizador; o fallback e da propria tela.
          // `err.message` nunca chega aqui — e do backend, em ingles.
          if (err.friendly && Array.isArray(err.friendly.lines) && err.friendly.code !== 'UNKNOWN') {
            this.error = err.friendly
          } else {
            this.error = { lines: ['Infelizmente tivemos um problema ao gerar sua recarga automática'], support: true }
          }
        }
        this.userCardFocus()
      })
    },
    debounceSubmitSource (event) {
      if (!event) return
      event.preventDefault()
      const source = event.target
      const isSubmitTrigger = source && (source.tagName === 'INPUT' || source.tagName === 'BUTTON')
      if (isSubmitTrigger) {
        source.disabled = true
        setTimeout(() => { source.disabled = false }, SUBMIT_DEBOUNCE_MS)
      }
    },
    isRechargeAmountInRange () {
      return this.automaticRechargeAmount >= MIN_RECHARGE_AMOUNT && this.automaticRechargeAmount <= MAX_RECHARGE_AMOUNT
    },
    userCardFocus () {
      this.$refs.userCardNumber.focus()
    },
    validateCardExpiration () {
      if (!this.userCardExpiryMonth || !this.userCardExpiryYear || this.userCardExpiryYear.length !== 4) return
      const expirationValidation = cardValidator.expirationDate(`${this.userCardExpiryMonth}/${this.userCardExpiryYear}`)
      if (expirationValidation.isValid) {
        this.error = null
      } else {
        this.error = {
          message: 'É necessário informar uma data de expiração válida com mês e ano atual ou futuro. Por favor, verifique os campos e tente novamente.'
        }
      }
    },
    openAutomaticRechargeModal () {
      this.getFinancialData()
      $(this.$refs.automaticRechargeRequest).modal('show')
    },
    closeAutomaticRechargeModal () {
      this.resetCharge()
      $(this.$refs.automaticRechargeRequest).modal('hide')
    },
    goToSubscription () {
      const $modal = $(this.$refs.automaticRechargeRequest)
      this.resetCharge()
      $modal.one('hidden.bs.modal', () => {
        this.$router.push('/subscription')
      })
      $modal.modal('hide')
    },
    sanitizeCardNumber () {
      this.userCardNumber = this.userCardNumber.replace(/[^0-9]/g, '')
    },
    handlePaste (event) {
      const pastedData = event.clipboardData.getData('Text')
      event.preventDefault()
      this.userCardNumber = pastedData.replace(/[^0-9]/g, '')
    },
    mobileNoSavingUsage () {
      const price = this.isRatePlanNew ? NEW_MOBILE_PRICES[0] : (this.isRateplanLegacy ? LEGACY_MOBILE_PRICES[0] : MOBILE_PRICES[0])
      const mobileTariff = Number(price.replace(',', '.'))
      if (!isNaN(mobileTariff)) return mobileTariff * 1000
      return 0
    },
    fixedlineNoSavingUsage () {
      const price = this.isRatePlanNew ? NEW_FIXEDLINE_PRICE : (this.isRateplanLegacy ? LEGACY_FIXEDLINE_PRICES[0] : FIXEDLINE_PRICE)
      const fixedlineTariff = Number(price.replace(',', '.'))
      if (!isNaN(fixedlineTariff)) return fixedlineTariff * 1000
      return 0
    },
    mobileSavingUsage () {
      const amountPosition = this.getPositionByAmount(this.automaticRechargeAmount)
      const price = this.isRatePlanNew ? NEW_MOBILE_PRICES[amountPosition] : (this.isRateplanLegacy ? LEGACY_MOBILE_PRICES[amountPosition] : MOBILE_PRICES[amountPosition])
      const mobileTariff = Number(price.replace(',', '.'))
      if (!isNaN(mobileTariff)) return mobileTariff * 1000
      return 0
    },
    fixedlineSavingUsage () {
      const amountPosition = this.getPositionByAmount(this.automaticRechargeAmount)
      const price = this.isRatePlanNew ? NEW_FIXEDLINE_PRICE : (this.isRateplanLegacy ? LEGACY_FIXEDLINE_PRICES[amountPosition] : FIXEDLINE_PRICE)
      const fixedlineTariff = Number(price.replace(',', '.'))
      if (!isNaN(fixedlineTariff)) return fixedlineTariff * 1000
      return 0
    }
  },
  computed: {
    showRechargeActiveUserLimitNotice () {
      const organization = this.$store.state.auth.organization || {}
      if (isOrganizationUserLimitExempt(organization)) return false
      const createdAtRaw = organization.created_at || organization.createdAt
      if (this.inviteEligibilityCutoffDate && createdAtRaw) {
        const createdAt = new Date(createdAtRaw)
        const cutoffDate = new Date(this.inviteEligibilityCutoffDate)
        if (!isNaN(createdAt.getTime()) && !isNaN(cutoffDate.getTime())) {
          return createdAt >= cutoffDate
        }
      }
      return !this.canInvite
    },
    rechargeActiveUsersLimitLabel () {
      if (this.rechargeActiveUsersLimit === null) return 'N/D'
      return this.rechargeActiveUsersLimit
    },
    mobilePrice () {
      const prices = this.isRatePlanNew ? NEW_MOBILE_PRICES : (this.isRateplanLegacy ? LEGACY_MOBILE_PRICES : MOBILE_PRICES)
      return prices[this.getPositionByAmount(this.automaticRechargeAmount)]
    },
    fixedlinePrice  () {
      if (this.isRatePlanNew) return NEW_FIXEDLINE_PRICE
      if (this.isRateplanLegacy) {
        return LEGACY_FIXEDLINE_PRICES[this.getPositionByAmount(this.automaticRechargeAmount)]
      }
      return FIXEDLINE_PRICE
    },
    averageSaving () {
      const mobileNoSaving = this.mobileNoSavingUsage()
      const fixedNoSaving = this.fixedlineNoSavingUsage()
      const mobileSaving = this.mobileSavingUsage()
      const fixedSaving = this.fixedlineSavingUsage()

      const noSavingUsage = mobileNoSaving + fixedNoSaving
      const savingUsage = mobileSaving + fixedSaving
      return noSavingUsage - savingUsage
    }
  },
  watch: {
    '$store.state.auth.financialData': function () {
      this.getFinancialData()
    },
    userCardExpiryYear () {
      if (this.userCardExpiryYear && this.userCardExpiryYear.length === 4) {
        const currentYear = new Date().getFullYear()
        const year = Number(this.userCardExpiryYear, 10)
        if (isNaN(year) || year < currentYear) {
          this.error = {
            message: 'É necessário informar um ano de expiração válido.'
          }
          return
        }
        this.error = null
      } else {
        this.error = null
      }
      this.validateCardExpiration()
    },
    userCardExpiryMonth () {
      this.validateCardExpiration()
    },
    userCardNumber () {
      const cardNumberValidation = cardValidator.number(this.userCardNumber)
      if (this.userCardNumber && cardNumberValidation.isPotentiallyValid) {
        if (cardNumberValidation.card) {
          // Sem lista de bandeiras aceitas: quem decide é o Asaas, na
          // tokenização; o pbxapi devolve CREDIT_CARD_BRAND_NOT_SUPPORTED.
          // Tamanhos do número e do CVV vêm do card-validator, por bandeira.
          const { card } = cardNumberValidation
          this.error = null
          this.userCardBrand = card.niceType
          this.userCardSecurityCodeLength = card.code.size
          this.userCardNumberLength = Math.max(...card.lengths)
          if (this.userCardSecurityCode && this.userCardSecurityCode.length > card.code.size) this.userCardSecurityCode = ''
        } else {
          this.userCardBrand = null
          this.error = {
            message: 'É necessário informar um número de cartão válido.'
          }
        }
      } else {
        this.userCardBrand = null
        this.error = {
          message: 'É necessário informar um número de cartão válido.'
        }
      }

      // Número com um dos tamanhos válidos da bandeira: confere o dígito
      // verificador. Antes comparava com um tamanho em texto ('16') e nunca rodava.
      const card = cardNumberValidation.card
      if (this.userCardNumber && card && card.lengths.includes(this.userCardNumber.length)) {
        if (cardNumberValidation.isValid) {
          this.error = null
          this.userCardBrand = cardNumberValidation.card.niceType
        } else {
          this.userCardBrand = null
          this.error = {
            message: 'É necessário informar um número de cartão válido.'
          }
        }
      }

      // CVV preenchido antes do número: o tamanho mudou com a bandeira (Amex
      // pede 4), mas o watcher do CVV só roda quando o próprio CVV muda.
      if (!this.error && this.userCardSecurityCode &&
        !cardValidator.cvv(this.userCardSecurityCode, this.userCardSecurityCodeLength).isValid) {
        this.error = {
          message: 'É necessário informar o número do código de segurança válido.'
        }
      }
    },
    userCardSecurityCode () {
      const securityCodeValidation = cardValidator.cvv(this.userCardSecurityCode, this.userCardSecurityCodeLength)
      if (this.userCardSecurityCode && !securityCodeValidation.isValid) {
        this.error = {
          message: 'É necessário informar o número do código de segurança válido.'
        }
      } else {
        this.error = null
      }
    },
    automaticRechargeAmount (newAmount) {
      $(`#automaticRechargeSlider`).slider('setValue', this.getAmountPositionByAmount(newAmount))
    }
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/financial';

.automatic-recharge-modal {
  max-width: 920px;
  margin-left: auto;
  margin-right: auto;

  @include financial-modal-content;

  .automatic-recharge-modal-header {
    @include financial-modal-header;
  }

  .automatic-recharge-modal-footer {
    @include financial-modal-footer;
  }

  .automatic-recharge-btn-cancel {
    @include financial-btn-cancel;
  }

  .automatic-recharge-btn-submit {
    @include financial-btn-submit;
  }
}

.automaticRechargeAmount {
  text-align: center;
}

.automatic-recharge-card-column .form-group {
  margin-bottom: 0.4rem;
}
.automatic-recharge-card-column .form-group.automatic-recharge-card-last {
  margin-bottom: 0.1rem;
}
.automatic-recharge-card-column .automatic-recharge-card-title {
  font-size: 0.9rem;
  font-weight: 600;
  margin-bottom: 0.35rem;
}

@include financial-form-labels;

.automatic-recharge-card-column .form-group .d-flex {
  gap: 0.25rem;
}
.automatic-recharge-card-column .form-group .d-flex .input-group {
  flex: 1 1 auto;
}
.automatic-recharge-card-column .form-group .d-flex .input-group.mx-1 {
  margin-left: 0.25rem !important;
  margin-right: 0.25rem !important;
}

.automatic-recharge-card-column .form-text.small {
  margin-top: 0.05rem;
  margin-bottom: 0.2rem;
}

.automatic-recharge-card-column .automatic-recharge-financial-emails {
  margin-top: 0.15rem;
}

@include financial-form-prices;

@include financial-form-economy;

.charge-limit-message {
  font-size: 0.8rem;
  color: $financial-text-secondary;
  margin: 0.75rem 0 0;
  text-align: left;
  line-height: 1.4;
  display: flex;
  align-items: flex-start;
  gap: 0.35rem;
}

.charge-limit-icon {
  font-size: 0.8rem;
  color: $financial-text-secondary;
}

.charge-limit-icon-btn {
  border: none;
  background: transparent;
  padding: 0;
  margin-top: 0.15rem;
  line-height: 1;
  cursor: pointer;
}

.charge-limit-link {
  color: #2d63f6 !important;
  font-weight: 600;
  margin-left: 0.25rem;
  text-decoration: none;

  &:hover,
  &:focus,
  &:active,
  &:visited {
    color: #2d63f6 !important;
  }

  &:hover,
  &:focus {
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AutomaticRecharge/New.vue